"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const pulse_components_1 = require("@pcs/pulse-components");
const clsx_1 = __importDefault(require("clsx"));
const react_redux_1 = require("react-redux");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../../helper");
const store_1 = __importDefault(require("../../../../reviews-modal/store"));
const constants_1 = require("../../../../reviews-modal/slice/sliceReview/constants");
const sliceReview_1 = require("../../../../reviews-modal/slice/sliceReview");
const CancelReviewModal_1 = __importDefault(require("../../CancelReviewModal"));
const ManageNotificationsModal_1 = __importDefault(require("../../ManageNotificationsModal"));
const AddUserLockedRoundModal_1 = __importDefault(require("../../AddUserLockedRoundModal"));
const withMoveReviewModal_1 = __importDefault(require("../../../HOC/withMoveReviewModal"));
const withPublicLinkModal_1 = __importDefault(require("../../../HOC/withPublicLinkModal"));
var REVIEW_ACTIONS;
(function (REVIEW_ACTIONS) {
    REVIEW_ACTIONS["newRound"] = "new-round";
    REVIEW_ACTIONS["reviewSetting"] = "review-setting";
    REVIEW_ACTIONS["cancelReview"] = "cancel-review";
    REVIEW_ACTIONS["notifyReviewer"] = "notify-reviewer";
    REVIEW_ACTIONS["addUserToLockedRound"] = "add-user-to-locked-round";
})(REVIEW_ACTIONS || (REVIEW_ACTIONS = {}));
const isViewReviews = helper_1.VIEW_REVIEW_PERMISSION === 'y';
const isReviewAdmin = helper_1.REVIEWS_ADMIN_PERMISSION === 'y';
const isCreateReview = helper_1.CREATE_REVIEW_PERMISSION === 'y';
const CURRENT_USER_ID = helper_1.USER.id;
const MenuReviewOption = (props) => {
    var _a, _b, _c;
    const { reviewRound, ticketId, blockRound, setOpenReviewModal, openMoveReviewModal, } = props;
    const [openCancelModal, setOpenCancelModal] = (0, react_1.useState)(false);
    const [options, setOptions] = (0, react_1.useState)([]);
    const [openManageNotificationModal, setOpenManageNotificationModal] = (0, react_1.useState)(false);
    const [isOpenAddLockedUserModal, setIsOpenAddLockedUserModal] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleOpenCreateNewModal = () => {
        if (setOpenReviewModal) {
            setOpenReviewModal(true);
        }
        dispatch((0, sliceReview_1.openModal)({
            status: constants_1.MODE.newRound,
            ticketId,
            round: {
                ...reviewRound,
                id: (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId),
                source: [reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundSources[0]],
                job_id: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobId,
                job_title: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobTitle,
                round_number: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundNumber,
                last_round_number: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.lastRoundNumber,
            },
        }));
    };
    const handleOpenReviewSetting = () => {
        if (setOpenReviewModal) {
            setOpenReviewModal(true);
        }
        dispatch((0, sliceReview_1.openModal)({
            status: constants_1.MODE.update,
            round: {
                ...reviewRound,
                id: (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId),
            },
        }));
    };
    const handleCancelReview = () => {
        setOpenCancelModal(true);
    };
    const handleCancelModal = () => {
        setOpenCancelModal(false);
    };
    const handleOpenNotifyReviewers = () => {
        setOpenManageNotificationModal(true);
    };
    const closeManageNotificationsModal = () => {
        setOpenManageNotificationModal(false);
    };
    const handleOpenAddLockedUserModal = () => {
        setIsOpenAddLockedUserModal(true);
    };
    const handleOpenAction = (0, react_1.useCallback)((action) => {
        switch (action) {
            case REVIEW_ACTIONS.newRound:
                handleOpenCreateNewModal();
                break;
            case REVIEW_ACTIONS.cancelReview:
                handleCancelReview();
                break;
            case REVIEW_ACTIONS.notifyReviewer:
                handleOpenNotifyReviewers();
                break;
            case REVIEW_ACTIONS.addUserToLockedRound:
                handleOpenAddLockedUserModal();
                break;
            default:
                handleOpenReviewSetting();
                break;
        }
    }, [blockRound, reviewRound]);
    const handleMoveReviewToAnotherProject = () => {
        openMoveReviewModal(reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.reviewId);
    };
    const MENU_OPTIONS = [
        {
            enabled: isViewReviews,
            label: 'Review Actions',
            subMenuItems: [
                {
                    label: 'Review Settings',
                    iconClasses: {
                        icon: 'fal fa-gear',
                    },
                    onClick: () => handleOpenAction(REVIEW_ACTIONS.reviewSetting),
                },
                {
                    label: 'New Review Round',
                    iconClasses: {
                        icon: 'fal fa-plus-circle',
                    },
                    onClick: () => handleOpenAction(REVIEW_ACTIONS.newRound),
                },
                {
                    label: 'Cancel Round',
                    iconClasses: {
                        icon: 'fal fa-times-circle',
                    },
                    onClick: () => handleOpenAction(REVIEW_ACTIONS.cancelReview),
                },
                {
                    label: 'Notify Reviewers',
                    iconClasses: {
                        icon: 'fal fa-envelope',
                    },
                    onClick: () => handleOpenAction(REVIEW_ACTIONS.notifyReviewer),
                },
                {
                    label: 'Add View Only Reviewers',
                    iconClasses: {
                        icon: 'fal fa-user',
                    },
                    onClick: () => handleOpenAction(REVIEW_ACTIONS.addUserToLockedRound),
                },
                {
                    label: 'Move Review',
                    iconClasses: {
                        icon: 'fal fa-arrow-turn-down-right',
                    },
                    onClick: handleMoveReviewToAnotherProject,
                },
            ],
        },
    ];
    (0, react_1.useEffect)(() => {
        var _a, _b;
        let isManagePermission = false;
        if (reviewRound) {
            reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.stages.forEach((stage) => {
                if (!isManagePermission) {
                    const reviewers = stage === null || stage === void 0 ? void 0 : stage.reviewers.find((reviewer) => {
                        return reviewer.id === Number(CURRENT_USER_ID);
                    });
                    if (reviewers) {
                        isManagePermission = reviewers.manage;
                    }
                }
            });
        }
        const menuOptions = (_b = (_a = MENU_OPTIONS[0]) === null || _a === void 0 ? void 0 : _a.subMenuItems) === null || _b === void 0 ? void 0 : _b.filter((option) => {
            if (!isManagePermission && !isReviewAdmin) {
                if (isCreateReview) {
                    return (option.label === 'New Review Round' ||
                        option.label === 'Notify Reviewers');
                }
                return option.label === 'Notify Reviewers';
            }
            if (blockRound) {
                return option.label === 'Add View Only Reviewers';
            }
            return option.label !== 'Add View Only Reviewers';
        });
        setOptions([
            {
                enabled: MENU_OPTIONS[0].enabled,
                label: MENU_OPTIONS[0].label,
                subMenuItems: menuOptions,
            },
        ]);
    }, [reviewRound, ticketId, blockRound]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        options.map((menuOption) => {
            var _a;
            if (!menuOption.enabled) {
                return false;
            }
            if (Object.keys(menuOption).includes('subMenuItems')) {
                return (react_1.default.createElement("div", { key: `${menuOption.label}`, className: styles_modules_less_1.default['action-menu__listItem'] }, (_a = menuOption.subMenuItems) === null || _a === void 0 ? void 0 : _a.map((subMenuItem) => {
                    const { enabled = true, iconClasses, ...restSubMenuItemProps } = subMenuItem;
                    if (enabled) {
                        return (react_1.default.createElement(pulse_components_1.PulseButton, { key: `${subMenuItem.label}`, icon: true, variant: pulse_components_1.ButtonVariants.text, ...restSubMenuItemProps, classes: [
                                (0, clsx_1.default)(styles_modules_less_1.default['action-menu__itemDefault'], styles_modules_less_1.default['action-menu__itemGroup']),
                            ], iconClasses: {
                                root: styles_modules_less_1.default['action-menu__btn--iconRoot'],
                                ...iconClasses,
                            } }));
                    }
                    return react_1.default.createElement(react_1.default.Fragment, null);
                })));
            }
            const { ...restMenuItemProps } = menuOption;
            return (react_1.default.createElement(pulse_components_1.PulseButton, { key: `${menuOption.label}`, ...restMenuItemProps, classes: [(0, clsx_1.default)(menuOption.classes, styles_modules_less_1.default['action-menu__item'])] }));
        }),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
            openCancelModal && (react_1.default.createElement(CancelReviewModal_1.default, { round: {
                    title: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.title,
                    id: (_a = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) !== null && _a !== void 0 ? _a : reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId,
                }, isOpen: openCancelModal, handleClose: handleCancelModal })),
            openManageNotificationModal && (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement("div", null, "Loading...") },
                react_1.default.createElement(ManageNotificationsModal_1.default, { open: openManageNotificationModal, onModalClose: closeManageNotificationsModal, jobId: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.jobId, assetId: (_c = (_b = reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundSources[0]) === null || _b === void 0 ? void 0 : _b.asset) === null || _c === void 0 ? void 0 : _c.id, roundId: reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id }))),
            react_1.default.createElement(AddUserLockedRoundModal_1.default, { open: isOpenAddLockedUserModal, setOpenModal: setIsOpenAddLockedUserModal, roundId: (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId) }))));
};
const MenuData = ({ ticketId = 0, openMoveReviewModal, }) => {
    const { reviewRound, blockRound, setOpenReviewModal } = (0, react_redux_1.useSelector)((state) => state.review);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_redux_1.Provider, { store: store_1.default },
            react_1.default.createElement(MenuReviewOption, { reviewRound: reviewRound, ticketId: ticketId, blockRound: blockRound, setOpenReviewModal: setOpenReviewModal, openMoveReviewModal: openMoveReviewModal }))));
};
exports.default = (0, withMoveReviewModal_1.default)((0, withPublicLinkModal_1.default)(MenuData));
